// @mui
import Box from '@mui/material/Box';
// routes
import { usePathname } from 'src/routes/hook';
//
// import { WhatsappGeneral } from 'src/components/connect';
import Footer from './footer';
import Header from './header';
// import { CardButton } from '../_common';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function MainLayout({ children }: Props) {
  const pathname = usePathname();

  const isHome = pathname === '/';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: 1 }}>
      <Header />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ...(!isHome && {
            pt: { xs: 8, md: 10 },
          }),
        }}
      >
        {children}
        {/* <WhatsappGeneral phone="97470171712" /> */}
      </Box>

      <Footer />
      {/* Floating Cart Button on all pages */}
      {/* <Box
        sx={{
          position: 'fixed',
          top: { xs: 96, md: 120 }, // move higher above the bottom edge
          right: { xs: 16, md: 40 },
          zIndex: 1300,
          boxShadow: 3,
        }}
      >
        <CardButton />
      </Box> */}
    </Box>
  );
}
